import { NewCustomerInfo } from "./NewCustomerForm";
import { webApiUrl } from "../data/constants";

const CreateCustomer = async (
  data: NewCustomerInfo,
  token: string
  ): Promise<Response> => {
  const request = new Request(
    `${webApiUrl}/CreateCompanyEndpoint/company/new`,
    {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    }
  );
  return await fetch(request);
};

export default CreateCustomer;
